import { createContext, useContext, useEffect, useState } from "react";

const ModeContext = createContext({ mode: "standard", setMode: () => {} });

export function ModeProvider({ children }) {
  const [mode, setMode] = useState(() => {
    if (typeof window === "undefined") return "standard";
    return localStorage.getItem("infralytics_mode") || "standard";
  });
  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem("infralytics_mode", mode);
  }, [mode]);
  return (
    <ModeContext.Provider value={{ mode, setMode, isStandard: mode === "standard", isAnalyst: mode === "analyst" }}>
      {children}
    </ModeContext.Provider>
  );
}

export function useMode() {
  return useContext(ModeContext);
}
